import React from 'react';
import ThemedButton from '../CommonComponents/ThemedButtons';
import Dropdown from '../CommonComponents/Dropdown';
type Props = {
  closeModal: Function;
  addNewBotApi: Function;
};
type State = {
  botID: string;
  botName: string;
  awareENV: string;
  awareEnvURL: string;
  botIconURL: string;
  Environment: { value: string; id: number; envName: string; envURL?: string }[];
  selectedEnvironment: { value: string; id: number; envName: string; envURL?: string };
};
export default class AddBot extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
    this.selectEnvironment = this.selectEnvironment.bind(this);
  }

  setInitialState(): State {
    return {
      botID: '',
      botName: '',
      awareENV: '',
      awareEnvURL: '',
      botIconURL: '',
      Environment: [
        {
          value: 'A.ware Production (https://aware.senseforth.com)',
          id: 0,
          envName: 'A.ware Production',
          envURL: 'https://aware.senseforth.com',
        },
        {
          value: 'A.ware Pre-ProdOld (https://awareuat.senseforth.com)',
          id: 1,
          envName: 'A.ware Pre-ProdOld',
          envURL: 'https://awareuat.senseforth.com',
        },
        {
          value: 'A.ware PreProdNew (https://aware-preprod.senseforth.com)',
          id: 2,
          envName: 'A.ware PreProdNew',
          envURL: 'https://aware-preprod.senseforth.com',
        },
        {
          value: 'Flyfish Production (https://flyfish.senseforth.com)',
          id: 3,
          envName: 'Flyfish Production',
          envURL: 'https://flyfish.senseforth.com',
        },
        {
          value: 'FlyfishUAT (https://flyfishuat.senseforth.com)',
          id: 4,
          envName: 'Flyfish UAT',
          envURL: 'https://flyfishuat.senseforth.com',
        },
      ],
      selectedEnvironment: {
        value: '',
        id: -1,
        envName: '',
        envURL: '',
      },
    };
  }

  selectEnvironment(index: number | undefined) {
    this.setState({
      selectedEnvironment:
        typeof index === 'number'
          ? this.state.Environment[index]
          : { value: '', id: -1, envName: '', envURL: '' },
    });
  }
  render() {
    return (
      <div>
        <div style={{ lineHeight: 3.3, width: '475px' }} className='add-new-bot-modal'>
          <div style={{ marginBottom: '20px' }}>
            <input
              type='text'
              placeholder=''
              className='input-fields'
              onChange={(event) => {
                this.setState({
                  botID: event.target.value.split(' ').join(''),
                });
              }}
              style={{ fontFamily: 'OpenSans' }}
            />
            {this.state.botID === '' && (
              <label
                style={{
                  position: 'absolute',
                  color: 'rgba(0,0,0,0.6)',
                  left: '30px',
                  marginTop: '5px',
                  fontSize: '14px',
                }}
                className='astrik'>
                Bot ID
              </label>
            )}
            <div
              id='botId-validation-error'
              style={{
                fontSize: '10px',
                letterSpacing: '-0.15px',
                textAlign: 'right',
                color: '#ff0000',
                margin: ' -20px 15px -20px 0px',
              }}></div>
          </div>
          <div style={{ marginBottom: '20px' }}>
            <input
              type='text'
              placeholder=''
              className='input-fields'
              onChange={(event) => {
                this.setState({
                  botName: event.target.value,
                });
              }}
              maxLength={140}
              style={{ fontFamily: 'OpenSans' }}
            />
            {this.state.botName === '' && (
              <label
                style={{
                  position: 'absolute',
                  color: 'rgba(0,0,0,0.6)',
                  left: '30px',
                  marginTop: '5px',
                  fontSize: '14px',
                }}
                className='astrik'>
                Bot Name
              </label>
            )}
            <div
              id='fname-validation-error'
              style={{
                fontSize: '10px',
                letterSpacing: '-0.15px',
                textAlign: 'right',
                color: '#ff0000',
                margin: ' -20px 15px -20px 0px',
              }}></div>
          </div>

          {/* <div style={{ marginBottom: '20px' }}>
            <input
              type='text'
              placeholder=''
              className='input-fields'
              onChange={(event) => {
                this.setState({
                  awareEnvURL: event.target.value,
                });
              }}
              maxLength={140}
              style={{ fontFamily: 'OpenSans' }}
            />
            {this.state.awareEnvURL === '' && (
              <label
                style={{
                  position: 'absolute',
                  color: 'rgba(0,0,0,0.6)',
                  left: '30px',
                  marginTop: '5px',
                  fontSize: '14px',
                }}
                className='astrik'>
                A.ware Environment URL
              </label>
            )}
            <div
              id='lname-validation-error'
              style={{
                fontSize: '10px',
                letterSpacing: '-0.15px',
                textAlign: 'right',
                color: '#ff0000',
                margin: ' -20px 15px -20px 0px',
              }}></div>
          </div> */}

          <div style={{ marginBottom: '20px' }}>
            <input
              type='text'
              placeholder=''
              className='input-fields'
              onChange={(event) => {
                this.setState({
                  botIconURL: event.target.value,
                });
              }}
              maxLength={140}
              style={{ fontFamily: 'OpenSans' }}
            />
            {this.state.botIconURL === '' && (
              <label
                style={{
                  position: 'absolute',
                  color: 'rgba(0,0,0,0.6)',
                  left: '30px',
                  marginTop: '5px',
                  fontSize: '14px',
                }}
                className='astrik'>
                Bot Icon URL
              </label>
            )}
            <div
              id='lname-validation-error'
              style={{
                fontSize: '10px',
                letterSpacing: '-0.15px',
                textAlign: 'right',
                color: '#ff0000',
                margin: ' -20px 15px -20px 0px',
              }}></div>
          </div>
          <div style={{ marginBottom: '20px' }}>
            <div>
              <Dropdown
                selected={this.state.selectedEnvironment.value}
                options={this.state.Environment.map((agent) => agent.value)}
                placeholder='Environment'
                onSelectionChange={this.selectEnvironment}
                filterType='external'
              />
            </div>

            {/* <input
              type='text'
              placeholder=''
              className='input-fields'
              onChange={(event) => {
                this.setState({
                  awareENV: event.target.value,
                });
              }}
              maxLength={140}
              style={{ fontFamily: 'OpenSans' }}
            /> */}
            {/* {this.state.awareENV === '' && (
              <label
                style={{
                  position: 'absolute',
                  color: 'rgba(0,0,0,0.6)',
                  left: '30px',
                  marginTop: '5px',
                  fontSize: '14px',
                }}
                className='astrik'>
                Environment
              </label>
            )} */}

            <div
              id='lname-validation-error'
              style={{
                fontSize: '10px',
                letterSpacing: '-0.15px',
                textAlign: 'right',
                color: '#ff0000',
                margin: ' -20px 15px -20px 0px',
              }}></div>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div style={{ marginRight: '10px' }}>
            <ThemedButton
              theme='3'
              title='Cancel'
              onClick={() => {
                this.props.closeModal();
              }}
            />
          </div>
          <ThemedButton
            theme='4'
            title={'Add'}
            onClick={() => {
              this.props.addNewBotApi(
                this.state.botID,
                this.state.botName,
                this.state.selectedEnvironment.envName,
                this.state.selectedEnvironment.envURL,
                this.state.botIconURL
              );
            }}
            disabled={
              this.state.botID !== '' &&
              this.state.botName !== '' &&
              this.state.selectedEnvironment.envName !== '' &&
              this.state.selectedEnvironment.envURL !== '' &&
              this.state.botIconURL !== ''
            }
          />
        </div>
      </div>
    );
  }
}
